const form = require('./form');

const dashboard = require('./dashboard');

const pick = require('./pick');

const upload = require('./upload');

module.exports = {
  dashboard,
  form,
  pick,
  upload,
  VERSION: "2.5.3"
};